import React from "react";

import { connect } from 'react-redux'
import Footer from "components/Footer/Footer.js";
import { backgroundImages } from './BackImages';

import { authActions } from 'modules/auth/actions';
import { Spinner } from 'components/Icons/Spinner' ; 

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
  Alert,
} from "reactstrap";





class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      formData: {
          user: this.props.lastLogin,
          password: ''
        },
      formErrors: {
          isValid: false
      },
      // Get an random background
      back: backgroundImages[Math.floor(Math.random() * backgroundImages.length)]
    }
 }

  handleKeyPress = ( event ) => {
    if(event.charCode===13){
      this.props.login (this.props.school.school_id,this.state.formData.user, this.state.formData.password )
    } 
  }

  handleInputChange = (event) => {
 
    this.setState({ formData : { ...this.state.formData, [event.target.name]: event.target.value} });
  }
  
  componentDidMount() {
    document.body.classList.toggle("login-page");
  }
  componentWillUnmount() {
    document.body.classList.toggle("login-page");
  }
  render() {
   

    return (
      <>
        <div className="login-page">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" lg="4" md="6">
                <Form action="" className="form" method="">
                  <Card className="card-login">
                    <CardHeader>
                      <CardHeader>
                        <img className="mx-auto d-block"  src={this.props.school.image} alt="logo" height="100"/>
                          <br/> 
                        <h5 className="text-center text-muted">{this.props.school.name} </h5>
                      </CardHeader>
                    </CardHeader>
                    {this.props.auth.isSubmitting?
                            
                              <h2 className="text-center text-muted"><Spinner atom={true} /></h2>
                             
                        :
                        <>
                          <Alert
                              color="danger"
                              isOpen={this.props.auth.displayError}
                              style={{ margin: "0px 15px"}} 
                          >
                              <span>
                                  Los datos ingresados son incorrectos
                              </span>
                          </Alert>
                    
                          <CardBody>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="nc-icon nc-single-02" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input 
                                name="user"
                                placeholder="usuario" 
                                type="text" 
                                onChange={this.handleInputChange}
                                onKeyPress={this.handleKeyPress} 
                                defaultValue={this.props.lastLogin}
                                />
                            </InputGroup>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="nc-icon nc-key-25" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                name="password"
                                placeholder="contraseña"
                                type="password"
                                autoComplete="off"
                                onChange={this.handleInputChange}
                                onKeyPress={this.handleKeyPress} 
                              />
                            </InputGroup>
                            
                          </CardBody>
                          <CardFooter>
                            <Button
                              block
                              className="mb-3"
                              color="primary"
                              disabled={this.props.auth.isSubmitting}
                              onClick={(e) => {
                                          this.props.login (this.props.school.school_id,this.state.formData.user, this.state.formData.password )
                                          
                                        } 
                                      }
                            >
                            Ingresar
                            </Button>
                          </CardFooter>
                        </>
                  }
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
          <div
            className="full-page-background"
            style={{
              backgroundImage: `url(${this.state.back.src})`,
            }}
          />
        </div>
        <Footer fluid tagLine={this.state.back.tagLine} flag={this.state.back.flag}/>
       </>
    );
  }
}


const mapStateToProps = state => {
  return {
    school: state.config.school ,
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => {
return {
  login: (schoolID, loginID, password) => {
      dispatch(authActions.login(schoolID, loginID, password));
    } 
}
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);
